import { render, staticRenderFns } from "./supplyServiceCapability.vue?vue&type=template&id=0b9ac45f&scoped=true"
import script from "./supplyServiceCapability.vue?vue&type=script&lang=js"
export * from "./supplyServiceCapability.vue?vue&type=script&lang=js"
import style0 from "./supplyServiceCapability.vue?vue&type=style&index=0&id=0b9ac45f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9ac45f",
  null
  
)

export default component.exports